import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FileUploadModal } from 'shared-components';
import { ApplicationState } from '../../../../store';
import {
  closeModal,
  openDocumentModal,
  openFinanceDocumentModal,
  openUploadFollowUpModal
} from '../../../../store/ui/actions';
import { saveDocuments, saveFinanceDocuments, saveFollowUpDocuments } from '../../../../store/student/actions';
import { getUploadUrl } from '../../../../store/data/actions';
import { IModal } from '../../../../store/ui/types';

const FileUploadLocal: React.FC<{ openModal: IModal | null }> = ({ openModal }) => {
  const dispatch = useDispatch();

  const uploadFileName = useSelector((state: ApplicationState) => state.data.uploadFile?.name);
  const uploadFileStatus = useSelector((state: ApplicationState) => state.data.uploadFile?.status);
  const uploadFileIndex = useSelector((state: ApplicationState) => state.data.uploadFile?.index);
  const isFileUploading = useSelector((state: ApplicationState) => state.data.uploadFile?.isFileUploading);

  const onClose = () => dispatch(closeModal());
  const onUploadFile = (openModal: IModal, fileName: string, fileType: string, fileIndex: number, file: File) =>
    dispatch(getUploadUrl(openModal, fileName, fileType, fileIndex, file));

  const onContinue = (
    sponsorType: string,
    sponsorKey: string,
    docType: string | null,
    docKey: string | null,
    interviewType: string,
    eventType: string,
    eventKey: string,
    interviewHash: string,
    attemptHash: string,
    isFinance: boolean,
    isFollowUp: boolean,
    isInterview: boolean,
    isRecordedInterview: boolean,
    uploadedBy?: string,
    shouldShowRequirements?: boolean,
    modalTitle?: string
  ) => {
    if (isFinance) {
      dispatch(saveFinanceDocuments(sponsorType, sponsorKey, docType, docKey));
      if (shouldShowRequirements) {
        dispatch(openFinanceDocumentModal(sponsorType, sponsorKey, docType, docKey, false, modalTitle));
      } else {
        dispatch(closeModal());
      }
    } else if (isFollowUp) {
      dispatch(saveFollowUpDocuments(sponsorType, sponsorKey, docType, docKey));
      if (shouldShowRequirements) {
        dispatch(openUploadFollowUpModal(sponsorType, sponsorKey, docType, docKey, modalTitle));
      } else {
        dispatch(closeModal());
      }
    } else {
      dispatch(saveDocuments(sponsorType, sponsorKey, docType, docKey));
      if (shouldShowRequirements) {
        dispatch(openDocumentModal(sponsorType, sponsorKey, docType, docKey, false, modalTitle));
      } else {
        dispatch(closeModal());
      }
    }
  };

  const props = {
    uploadFileName,
    uploadFileStatus,
    uploadFileIndex,
    isFileUploading,
    openModal,
    onClose,
    onUploadFile,
    onContinue
  };

  return <FileUploadModal {...props} />;
};

export default FileUploadLocal;
